import { WEB_HOST } from 'global/constants';

export const INTERVENTION_LANGUAGE_LABEL_ID =
  'select-label-intervention-language';

export const INTERVENTION_QUICK_EXIT_LABEL_ID = 'switch-label-quick-exit';

export const CUSTOM_LINK_PREFIX = `${WEB_HOST}/int/`;
